const initStoreSwitcherModal = () => {
  const storeSwitcherLinks = document.querySelectorAll('[data-store-switcher]');
  if (!storeSwitcherLinks.length) return;
  const popup = document.querySelector('[data-store-switcher-popup]');
  if (!popup) return;
  const popupCloseEls = popup.querySelectorAll('[data-store-switcher-popup-close]');
  const cartCountEl = document.querySelector('[data-cart-count]');

  const closePopup = () => {
    popup.classList.add('hidden');
    popup.classList.remove('flex');
    popupCloseEls.forEach((el) => el.removeEventListener('click', closePopup));
  };

  storeSwitcherLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const cartCount = Number(cartCountEl?.textContent) || 0;
      if (cartCount > 0) {
        e.preventDefault();
        popup.classList.add('flex');
        popup.classList.remove('hidden');
        popupCloseEls.forEach((el) => el.addEventListener('click', closePopup));
      }
    });
  });
};

export default initStoreSwitcherModal;
